/*
 * @Author: zhujuan
 * @Date: 2022-01-21 17:07:48
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-02-18 14:45:41
 * @Description:
 * @FilePath: /nqc-pc-ui/src/frameworks/http/services.js
 */

import { apiService } from './request'
import store from '@/frameworks/store'
// let prefix = 'NQCS/'
let prefix = 'NQCS/DoAction?act='
// 通用接口方法
export function requestApi(funName, params) {
  let UserId = store.state.user.loginUserInfo.UserId
  let UserName = store.state.user.loginUserInfo.username
  let HospitalCode = store.state.user.HospitalCode
  return apiService({
    url: `${prefix}${funName}`,
    method: 'post',
    data: { UserId, UserName, HospitalCode: '', ...params } // 多院区调整了模式，不再整体切换院区，保留原来的院区字段，避免接口缺少字段报错，赋值为空，在特定接口自己添加院区代码
  })
}
